// common
const common = {
  'common.Cancel': '取消',
  'common.Save': '保存',
  'common.add': '添加',
  'common.operation': '操作',
  'common.modify': '修改',
  'common.Edit': '编辑',
  'common.view': '查看',
  'common.delete': '删除',
  'common.sureDelete': '您确定要删除吗？',
  'common.deleteSuccess': '删除成功',
  'common.addSuccess': '添加成功',
  'common.modifySuccess': '修改成功',
  'common.ok': '确定',
  'common.cancel': '取消',
  'common.prompt': '提示',
  'common.advSearch': '高级搜索'
};

// HomeBody
const HomeBody = {
  'HomeBody.Taskbar': '任务栏',
  'HomeBody.Bench': '工作台',
  'HomeBody.reminder': '提醒',
  'HomeBody.noData': '暂无提醒数据',
  'HomeBody.Dashboard': '仪表盘'
};

// Login
const Login = {
  'Login.NormalLogin': '普通登录',
  'Login.DomainLogin': '域登录',
  'Login.UsernamePlaceholder': '用户名',
  'Login.PassworkPlaceholder': '密码',
  'Login.DomainUsernamePlaceholder': '工号',
  'Login.Login': '登录',
  'Login.userNameTip': '请输入用户名',
  'Login.DomainUserNameTip': '请输入工号',
  'Login.passwordTip': '请输入密码'
};

// RightBtns
const RightBtns = {
  'RightBtns.Report': '报表',
  'RightBtns.LockScreen': '锁定屏幕',
  'RightBtns.Settings': '设置',
  'RightBtns.Logoff': '退出登录',
  'RightBtns.ChangePassword': '修改密码',
  'RightBtns.ClearCache': '清除缓存',
  'RightBtns.ChangeThemeColor': '修改主题色',
  'RightBtns.DisplayMode': '显示模式',
  'RightBtns.SelectThemeColor': '选择主题色',
  'RightBtns.ChangeLanguage': '更换语言/Change Language',
  'RightBtns.SelectLanguage': '选择语言/Select Language',
  'RightBtns.About': '关于',
  'RightBtns.OK': '确定',
  'RightBtns.success': '操作成功',
  'RightBtns.sureLock': '您确定要锁定屏幕吗?',
  'RightBtns.sureLogoff': '您确定要退出登录吗?',
  'RightBtns.Version': '版本：',
  'RightBtns.VersionUpdate': '版本更新介绍',
  'RightBtns.ChangePassword': '修改密码',
  'RightBtns.OriginalPassword': '原密码',
  'RightBtns.NewPassword': '新密码',
  'RightBtns.Submit': '提交',
  'RightBtns.OriginalPasswordTip': '请输入原密码',
  'RightBtns.NewPasswordTip': '请输入新密码',
  'RightBtns.NewPasswordAgainTip': '请再次输入新密码',
  'RightBtns.Reminder': '提醒'
};

// PersonCenter
const PersonCenter = {
  'PersonCenter.title': '个人中心'
};

// Setting
const Setting = {
  'Setting.leftTitle': '必要功能',
  'Setting.rightTitle': '可选功能'
};

// TableData
const TableData = {
  'TableData.pleaseSelectARecord': '请选择一条记录',
  'TableData.sureCancelEdit': '您确定要取消编辑吗？'
};

// OrgChartData
const OrgChartData = {
  'OrgChartData.setting': '设置',
  'OrgChartData.saveStructure': '保存结构',
  'OrgChartData.up': '上一层',
  'OrgChartData.down': '下一层',
  'OrgChartData.sureSaveSturcture': '您确定要保存该结构吗？'
};

const Component = {
  'Component.component': '组件'
};

export default {
  ...Component,
  ...common,
  ...HomeBody,
  ...Login,
  ...RightBtns,
  ...PersonCenter,
  ...Setting,
  ...TableData,
  ...OrgChartData,
  add: '添加',
  edit: '编辑',
  save: '保存',
  cancel: '取消',
  view: '查看',
  modify: '修改',
  delete: '删除',
  choose: '选择'
};
